export default "__VITE_ASSET__BLa0j8JD__"